import {useEffect, useState} from 'react';

export const BotDetector = ({botContent, userContent}) => {
  const [isBot, setIsBot] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const userAgent = navigator.userAgent.toLowerCase();
    const botAgents = [
      'ia_archiver',
      'archive.org_bot',
      'googlebot',
      'bingbot',
      'slurp',
      'duckduckbot',
      'baiduspider',
      'yandexbot',
      'sogou',
      'exabot',
      'facebot',
      'twitterbot',
      'mj12bot',
      'ahrefsbot',
      'semrushbot',
      'dotbot',
      'spider',
      'crawler',
      'bot'
    ];

    setIsBot(botAgents.some((agent) => userAgent.includes(agent)));
  }, []);

  return isBot ? botContent : userContent;
};
